import React, { useEffect, useState, useCallback } from "react";
import Filters from "../components/Filters";
import { ErrorState } from "../components/EmptyState";
import { api, monthLabel, fmtNum } from "../lib/api";

export default function RekapRw() {
  const [filter, setFilter] = useState({ tahun: "2026", bulan: "september", rw: "", rt: "" });
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const load = useCallback(async () => {
    setLoading(true); setError(false);
    try { setData(await api.rekapRw(filter.tahun, filter.bulan)); }
    catch { setError(true); } finally { setLoading(false); }
  }, [filter.tahun, filter.bulan]);
  useEffect(() => { load(); }, [load]);

  return (
    <div className="space-y-5">
      <div>
        <h1 className="text-2xl sm:text-3xl font-extrabold text-[#0e2b26] tracking-tight">Rekapitulasi RT/RW</h1>
        <p className="text-sm text-[hsl(var(--muted-foreground))] mt-1">
          Periode <strong>{monthLabel(filter.bulan)} {filter.tahun}</strong>
        </p>
      </div>
      <Filters value={filter} onChange={setFilter} onRefresh={load} />
      {error ? <ErrorState onRetry={load} /> : (
        <div className="bg-white rounded-xl border border-[hsl(var(--border))] overflow-hidden">
          <div className="table-scroll">
            <table className="w-full text-sm" data-testid="rekap-rw-table">
              <thead className="bg-[hsl(var(--muted))]">
                <tr>
                  <th className="text-left px-4 py-3 font-bold uppercase text-xs tracking-wider">RW</th>
                  <th className="text-right px-4 py-3 font-bold uppercase text-xs tracking-wider">Jumlah RT</th>
                  <th className="text-right px-4 py-3 font-bold uppercase text-xs tracking-wider">Sudah</th>
                  <th className="text-right px-4 py-3 font-bold uppercase text-xs tracking-wider">Belum</th>
                  <th className="text-right px-4 py-3 font-bold uppercase text-xs tracking-wider">Progress</th>
                  <th className="text-right px-4 py-3 font-bold uppercase text-xs tracking-wider">Total</th>
                  <th className="text-right px-4 py-3 font-bold uppercase text-xs tracking-wider">L</th>
                  <th className="text-right px-4 py-3 font-bold uppercase text-xs tracking-wider">P</th>
                </tr>
              </thead>
              <tbody>
                {loading ? Array.from({ length: 10 }).map((_, i) => (
                  <tr key={`sk-row-${i}`} className="border-t border-[hsl(var(--border))]">
                    {Array.from({ length: 8 }).map((_, j) => (
                      <td key={`sk-cell-${i}-${j}`} className="px-4 py-3"><div className="skeleton h-3 w-14"></div></td>
                    ))}
                  </tr>
                )) : (data?.data || []).map((r) => (
                  <tr key={r.rw} className="border-t border-[hsl(var(--border))] hover:bg-[hsl(var(--muted))]/40">
                    <td className="px-4 py-3 font-bold text-[#0e2b26]">RW {r.rw}</td>
                    <td className="px-4 py-3 text-right">{r.jumlah_rt}</td>
                    <td className="px-4 py-3 text-right text-emerald-700 font-semibold">{r.sudah_mengisi}</td>
                    <td className="px-4 py-3 text-right text-red-600 font-semibold">{r.belum_mengisi}</td>
                    <td className="px-4 py-3 text-right">
                      <div className="inline-flex items-center gap-2">
                        <div className="w-16 h-2 rounded-full bg-[hsl(var(--muted))] overflow-hidden">
                          <div className="h-full bg-emerald-500" style={{ width: `${r.progress}%` }} />
                        </div>
                        <span className="text-xs font-semibold">{r.progress}%</span>
                      </div>
                    </td>
                    <td className="px-4 py-3 text-right font-semibold">{fmtNum(r.total_penduduk)}</td>
                    <td className="px-4 py-3 text-right">{fmtNum(r.laki_laki)}</td>
                    <td className="px-4 py-3 text-right">{fmtNum(r.perempuan)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
